import { render, staticRenderFns } from "./ConfigurarLista.vue?vue&type=template&id=769b91a1&"
import script from "./ConfigurarLista.vue?vue&type=script&lang=js&"
export * from "./ConfigurarLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports